export default __webpack_public_path__ + "static/m-devops-867877ba3e56acbe0cc09e876852b02c.jpg";